import {USPBanner} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/stream/stream.types';
import {Slot, UspList} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';
import {NonProductTileSpacingAdjustment} from '../helpers';

type Props = {
  gridColumns: number | undefined;
  streamPosition: number;
  usps: USPBanner['usps'];
  uspItemsToDisplayPerSlide?: number;
};

export const UspSliderNormalized: FC<Props> = ({
  gridColumns,
  streamPosition,
  usps,
  uspItemsToDisplayPerSlide,
}) => {
  return (
    <StyledSlot columns={gridColumns} position={streamPosition} Comp="li">
      <UspList
        testId="secondHandUspSlider"
        itemsPerSlide={uspItemsToDisplayPerSlide}
        durationPerItemInMs={2000}
        items={usps}
        type="primary"
      />
    </StyledSlot>
  );
};

const StyledSlot = styled(Slot)`
  ${NonProductTileSpacingAdjustment}
`;
